import { render } from "./PublicMenuPlan.vue?vue&type=template&id=6f53e131"
import script from "./PublicMenuPlan.vue?vue&type=script&lang=js"
export * from "./PublicMenuPlan.vue?vue&type=script&lang=js"

import "./PublicMenuPlan.vue?vue&type=style&index=0&id=6f53e131&lang=scss"

import exportComponent from "/home/runner/work/Gourmetta-RCS-Customer-Orders---Web-App/Gourmetta-RCS-Customer-Orders---Web-App/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__